const toggleButtons = document.querySelectorAll('.js-toggle');

toggleButtons.forEach(btn => btn.addEventListener('click', ({ currentTarget }) => {

  const { toggleTarget } = currentTarget.dataset;
  if (toggleTarget) currentTarget.closest(toggleTarget)?.classList.toggle('opened');
}));
